import { treaty } from '@elysiajs/eden';
import type { App } from '../../server/app';
import { getToken } from './token';

export const api = treaty<App>(window.location.origin, {
  headers: () => {
    const token = getToken();

    return token ? { authorization: `Bearer ${token}` } : {};
  },
}).api;

export type ApiData<T extends (...a: never[]) => Promise<{ data: unknown }>> = NonNullable<
  Awaited<ReturnType<T>>['data']
>;
